import { useState } from 'react';
import ComicCard from '@/components/feature/ComicCard';
import { manhwaComics } from '@/mocks/manhwa';

export default function HotComicsGrid() {
  const [activeTab, setActiveTab] = useState('hot');

  const tabs = [
    { key: 'hot', label: '热门推荐' },
    { key: 'new', label: '最新上架' },
    { key: 'completed', label: '已完结' },
    { key: 'featured', label: '精选推荐' },
  ];

  const getFilteredComics = () => {
    switch (activeTab) {
      case 'hot': return manhwaComics.filter(m => m.hot);
      case 'new': return manhwaComics.filter(m => m.newRelease);
      case 'completed': return manhwaComics.filter(m => m.status === '已完结');
      case 'featured': return manhwaComics.filter(m => m.featured);
      default: return manhwaComics;
    }
  };

  const displayComics = getFilteredComics();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight">
              热门漫画
              <br />
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最受欢迎的韩国漫画都在这里</p>
          </div>
          {/* Tab Switcher */}
          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-500 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Comics Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5" data-product-shop>
          {displayComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              status={comic.status}
              rating={comic.rating}
              coverImage={comic.coverImage}
              category={comic.category}
              tags={comic.tags}
              chapters={comic.chapters}
              slug={comic.slug}
            />
          ))}
        </div>
      </div>
    </section>
  );
}